import type React from 'react';

import { Popover } from '@material-ui/core';
import type { PopoverProps } from '@material-ui/core';

export interface IProps extends Omit<PopoverProps, 'open'> {
  bz?: unknown;
  open?: boolean;

  onRequestClose?: PopoverProps['onClose'];
}

const BzPopover: React.FC<IProps> = ({
  bz, // strip props out from DOM to prevent warning...
  children,
  open = false,
  onClose,
  onRequestClose,
  ...other
}) => {
  const popoverStyle = open
    ? other.style
    : {
        ...other.style,
        pointerEvents: 'none'
      };

  return (
    <Popover
      open={open}
      {...other}
      style={popoverStyle}
      onClose={onClose || onRequestClose}
      disableAutoFocus={true}
    >
      <>{children}</>
    </Popover>
  );
};

export default BzPopover;
